import React from "react";
import HighchartsReact, { HighchartsReactRefObject } from "highcharts-react-official";
import Highcharts from "highcharts";

import exporting from "highcharts/modules/exporting";
import exportData from "highcharts/modules/export-data";
import fullscreen from "highcharts/modules/full-screen";

exporting(Highcharts);
exportData(Highcharts);
fullscreen(Highcharts);

Highcharts.setOptions({
  lang: {
    thousandsSep: ",", //separator for thousand numbers in tooltips
    numericSymbols: ["k", "M", "B", "T"]
  }
});

export const MemoizedHighchart = React.memo(
  ({
    options,
    className,
    chartRef
  }: {
    options: any;
    className?: string;
    chartRef?: React.Ref<HighchartsReactRefObject>;
  }) => {
    return <HighchartsReact containerProps={{ className }} highcharts={Highcharts} options={options} ref={chartRef} />;
  }
);
